import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from "@angular/core";
import { MatChipListboxChange } from "@angular/material/chips";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { GraphComponent } from "@yfiles/yfiles";
import { Subscription } from "rxjs";
import { AppComponent } from "../../app.component";
import { getWarningsForLinqset, getWarningText, INSIGHTS_FIELD, Linqset, NODE_WARNING, NodeWarning } from "../../common/linqset-model";
import { User } from "../../common/user";
import { GraphProcessingService } from "../../model-services/graph-processing.service";
import { NodeDialogComponent } from "../../model-components/nodes/node-dialog.component";
import { LinqsetRepositoryService } from "../../model-services/linqset-repository.service";
import { UserService } from "../../user/user.service";

@Component({
    selector: 'app-warnings',
    templateUrl: './warnings.html',
    styleUrls: ['warnings.css'],
    standalone: false
})
export class WarningsComponent implements OnChanges, OnDestroy {
    @Input() linqset:Linqset
    @Input() graphComponent:GraphComponent

    public displayedColumns = ['type', 'name', 'warning1', 'warning2', 'warning3', 'edit'];

    public dataSource = new MatTableDataSource<NodeWarning>();
    @ViewChild(MatSort) sort!: MatSort;

    warnings:NodeWarning[] = []
    warningSelected:NODE_WARNING
    filterOptions:INSIGHTS_FIELD[] = []
    preferences:INSIGHTS_FIELD[] = []
    processingSubscription:Subscription
    userSubscription:Subscription

    user:User

    @Output() selectNodeEvent = new EventEmitter<string>();

    constructor(private graphProcessingService: GraphProcessingService, 
        private userService:UserService, private repoService:LinqsetRepositoryService, private dialog:MatDialog) {
            this.filterOptions = [
                INSIGHTS_FIELD.CAPACITY, INSIGHTS_FIELD.COST, INSIGHTS_FIELD.ANNUAL_HOURS, INSIGHTS_FIELD.PROCESSED, 
                INSIGHTS_FIELD.CARBON, INSIGHTS_FIELD.VALUE, INSIGHTS_FIELD.REVENUE
            ]
            this.user = this.userService.getUser()
            this.preferences = this.user.preferences.fieldTypes || this.filterOptions

            this.userSubscription = this.userService.userChangedEvent.subscribe(() => {
                this.user = this.userService.getUser()
                this.preferences = this.user.preferences.fieldTypes || this.filterOptions
                this.populateWarnings()
            })

            if (!this.processingSubscription) {
                this.processingSubscription = this.graphProcessingService.processCompletedEvent.subscribe(async e => {
                    this.populateWarnings()
                })
            }
    }

    ngOnDestroy(): void {
        if (this.userSubscription) this.userSubscription.unsubscribe()
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.populateWarnings()
    }
    
    isHelpOn() {
        return AppComponent.help
    }

    populateWarnings() {

        this.warnings = getWarningsForLinqset(this.linqset, this.preferences)

        if (!this.selectNodeEvent) {
            this.dataSource.data = []    
        }else {
            this.dataSource.data = this.warnings.filter(w => w.warnings.indexOf(this.warningSelected) >= 0)
            this.dataSource.sort = this.sort
        }
    }

    sortChange(event) {
        this.dataSource.data = event.direction===''?this.warnings:
            this.dataSource.data.sort((a,b) => {
                if (a[event.active] > b[event.active])
                    return (event.direction === "asc")?1:-1
                else return (event.direction === "asc")?-1:1
            })
    }

    onFilterClick(change:MatChipListboxChange) {
        this.preferences = change.value
        this.populateWarnings()
    }

    getWarningText(warning:NODE_WARNING) {
        return warning?getWarningText(warning):""
    }

    changeEvent() {
        this.populateWarnings()
    }

    selectRow(row:NodeWarning) {
        this.selectNodeEvent.emit(row.node._key)
    }

    editRow(row:NodeWarning) {
        const select = this.graphComponent && this.graphComponent.graph.nodes.find(n => n.tag.node && n.tag.node._key === row.node._key)
        if (select) NodeDialogComponent.open(this.dialog, this.linqset.organisation, this.graphComponent, this.linqset, this.repoService.organisationLinqset, select)
    }

    handleSelectWarning(warning:string) {
        this.warningSelected = warning as NODE_WARNING
        this.populateWarnings()
    }

    savePreferences() {
        this.user.preferences.fieldTypes = this.user.preferences.fieldTypes.filter(f => this.filterOptions.indexOf(f) < 0).concat(this.preferences)

        this.userService.saveUserPreferences(this.user)
    }
}  